'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'Selecteer tijd'
};

exports['default'] = locale;